import { useContext } from "react";

import classes from "./DrinkActions.module.css";
import CartContext from "../../../store/cart-context";

import CustomButton from "../../General_Elements/CustomButton/CustomButton";

const DrinkActions = (props) => {
  const cartCtx = useContext(CartContext);

  const result = cartCtx.items.find((item) => item._id === props.cocktail.id);

  const addToCartHandler = () => {
    // console.log("props.cocktail: ", props.cocktail)
    cartCtx.addItem({
      ...props.cocktail,
    });

    cartCtx.saveCart()
  };

  const removeFromCartHandler = () => {
    cartCtx.removeItem(props.cocktail.id);
    cartCtx.saveCart()
  };

  return (
    <div className={classes.drinkActions}>
      <div
         onClick={addToCartHandler}
        className={classes.addButton}
        style={{ width: props.width, height: props.height }}
      >
        {result? result.amount + " +" : "ADD"}
      </div>
      <CustomButton
        onClick={removeFromCartHandler}
        content={"MINUS"}
        type={"minusButton"}
        width="25%"
        height="90%"
      />
      <CustomButton
        onClick={props.onClose}
        content={"CLOSE"}
        type={"closeButton"}
        width="25%"
        height="90%"
      />
    </div>
  );
};

export default DrinkActions;
